module.exports = __webpack_public_path__ + "img/Classifier3.33d17752.png";